// extracted by mini-css-extract-plugin
export default {"root":"ActivityLogPane_root__OKUgM","title":"ActivityLogPane_title__4nXAq","tableWrap":"ActivityLogPane_tableWrap__l3zMj"};